// --- Core Libraries ---
import { configureStore } from "@reduxjs/toolkit";
import {
  FLUSH,
  PAUSE,
  PERSIST,
  persistReducer,
  persistStore,
  PURGE,
  REGISTER,
  REHYDRATE,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

// --- Root & Legacy Reducers ---
import rootReducer from "./reducers";
import authReducer from "./reducers/authentication";

// --- Feature Slices ---
import alertSlice from "./slices/alertSlice";
import applicantSlice from "./slices/applicantSlice";
import coreProgramSlice from "./slices/coreProgramSlice";
import discountSlice from "./slices/discountSlice";
import inquiriesSlice from "./slices/inquiriesSlice";
import locationSlice from "./slices/locationSlice";
import newAuthSlice from "./slices/newAuthSlice";
import productSlice from "./slices/productSlice";
import programSlice from "./slices/programSlice";
import registrationSlice from "./slices/registrationSlice";
import threadSlice from "./slices/threadSlice";

// --- Component-Specific Slices ---
import navbarSlice from "components/navigation/navbar/slice";
import programDetailsSlice from "components/programs/programDetails/programDetailsSlice";

const persistConfig = {
  key: "root",
  storage,
  whitelist: [
    "user",
    "applicant",
    "company",
    "loyacStaff",
    "parent",
    "supervisor",
    "communitycenter",
  ], // Only persist the user slice
};

const persistedReducer = persistReducer(persistConfig, authReducer);

// Use the existing thunk middleware with Redux Toolkit's configureStore
const store = configureStore({
  reducer: {
    ...rootReducer,
    rootDiscounts: discountSlice,
    rootCorePrograms: coreProgramSlice,
    alert: alertSlice,
    programDetails: programDetailsSlice,
    rootRegistrationSlice: registrationSlice,
    rootApplicantSlice: applicantSlice,
    rootThreadSlice: threadSlice,
    rootProgramSlice: programSlice,
    rootProductSlice: productSlice,
    rootInquiriesSlice: inquiriesSlice,
    navbar: navbarSlice,
    rootLocationSlice: locationSlice,
    rootNewAuthSlice: newAuthSlice,
    rootAuth: persistedReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// store.dispatch(checkForExpiredToken());

// Infer the `RootState` and `AppDispatch` types from the store itself
//@ts-ignore
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const persistor = persistStore(store);

export default store;
